export abstract class Version {

    static readonly VERSION_NUM: number = 670;
}
